import React from 'react';

import RevenueContractsIndex from '../../revenue-contracts/RevenueContractsIndex';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementContractManagementRevenueContractsTab = () => {
    const { routes, settings } = useProcurement();

    return (
        <RevenueContractsIndex
            updateSignedContractUrl={routes.updateSignedContractUrl}
            revDepartmentsOptions={settings.revDepartmentsOptions}
            ownersOptions={settings.ownersOptions}
        />
    );
};

export default ProcurementContractManagementRevenueContractsTab;
